<template>
    <div class="new_sale_order_batch">
        <div class="title sale_order_no">订单编号({{ dataObj.type }})：{{ dataObj.saleOrderNo }}</div>
        <div class="title cust_order_no" v-if="dataObj.custOrderNo">{{ dataObj.custOrderNo }}</div>
        <div class="info">
            <div class="info_item">
                <div class="info_item_title">
                    客户信息
                </div>
                <div class="info_item_content">
                    <el-form :model="dataObj"
                             label-position="left"
                             label-width="80px">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="客户">
                                    <div class="form_item_underline">
                                        {{ customerData }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" v-if="dataObj.method === '代理'">
                            <el-col :span="12">
                                <el-form-item label="代理商">
                                    <div class="form_item_underline">
                                        {{ dataObj.agentCustName || '' }}
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="佣金规则">
                                    <div class="form_item_underline" v-if="dataObj.commissionRule === '固定'">
                                        固定-{{ dataObj.commission || '' }}-{{ dataObj.commissionRuleCurrency || '' }}
                                    </div>
                                    <div class="form_item_underline" v-if="dataObj.commissionRule === '比例'">
                                        比例%-{{ dataObj.commission || '' }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div class="info_item">
                <div class="info_item_title">
                    下单信息
                </div>
                <div class="info_item_content">
                    <el-form :model="dataObj"
                             label-position="left"
                             label-width="80px">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="负责人">
                                    <div class="form_item_underline">
                                        {{ dataObj.custUserName || '' }}
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="下单时间">
                                    <div class="form_item_underline">
                                        {{ (dataObj.gmtCreate || '').split(' ')[0] }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="交期">
                                    <div class="form_item_underline"
                                         v-if="dataObj.goodsInfo && dataObj.goodsInfo.deliveryTimeList && dataObj.goodsInfo.deliveryTimeList.length > 1">
                                        <span v-for="(item, index) in dataObj.goodsInfo.deliveryTimeList"
                                            :key="index">
                                            <span>{{ item.time }}</span>
                                            <span style="color: #02A7F0;">【{{ item.mainPlanQuantity }}】</span>
                                        </span>
                                    </div>
                                    <div class="form_item_underline"
                                         v-if="dataObj.goodsInfo && dataObj.goodsInfo.deliveryTimeList && dataObj.goodsInfo.deliveryTimeList.length === 1">
                                        <span>{{ dataObj.goodsInfo.deliveryTimeList[0].time }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="goods" v-if="dataObj.goodsInfo">
            <div class="goods_title">
                物品信息
            </div>
            <div class="goods_content">
                <el-row>
                    <el-col :span="6">
                        <div class="goods_content_title">
                            <div class="goods_no">
                                {{ dataObj.goodsInfo.goodsNo }}
                            </div>
                            <div class="stock" v-if="stock">
                                现货
                            </div>
                        </div>
                        <div class="goods_content_item">
                            <span class="label">客户产品信息</span>
                        </div>
                        <div class="goods_content_item">
                            <span class="label">编号：</span>
                            <span class="value">{{ dataObj.custGoodsNo || '' }}</span>
                        </div>
                        <div class="goods_content_item">
                            <span class="label">色号：</span>
                            <span class="value">{{ dataObj.custColorName || '' }}</span>
                        </div>
                        <div class="goods_content_item">
                            <span class="label">款号：</span>
                            <span class="value">{{ dataObj.modelNumber || '' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-row>
                            <el-col :span="12">
                                <div class="goods_content_item">
                                    <span class="label">数量：</span>
                                    <span class="value">{{ dataObj.goodsInfo.mainQuantity }}</span>
                                    <span class="label">{{ dataObj.goodsInfo.mainQuantityUnit }}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="goods_content_item">
                                    <span class="label">单价：</span>
                                    <span class="value">{{ dataObj.goodsInfo.taxUnitPrice }}</span>
                                    <span class="label">{{ dataObj.currencyUnit === '人民币' ? '元' : dataObj.currencyUnit || '' }}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <div class="goods_content_item">
                                    <span class="label">附加费：</span>
                                    <span class="value">{{ getOtherFee }}</span>
                                    <span class="label">{{ dataObj.currencyUnit === '人民币' ? '元' : dataObj.currencyUnit || '' }}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="goods_content_item">
                                    <span class="label">总价：</span>
                                    <span class="value">{{ getTotalFee }}</span>
                                    <span class="label">{{ dataObj.currencyUnit === '人民币' ? '元' : dataObj.currencyUnit || '' }}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="6">
                        <el-row>
                            <el-col :span="12">
                                <div class="goods_content_item">
                                    <span class="label">克重：</span>
                                    <span class="value">{{ dataObj.goodsInfo.weight }}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="goods_content_item">
                                    <span class="label">幅宽：</span>
                                    <span class="value">{{ dataObj.goodsInfo.width }}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="goods_content_item">
                                    <span class="label">成分：</span>
                                    <span class="value">{{ dataObj.goodsInfo.blendName }}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="settlement">
            <div class="settlement_title">
                结算信息
            </div>
            <div class="settlement_content">
                <el-form :model="dataObj"
                            label-position="left"
                            label-width="80px"
                            style="width: 100%;">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="币种">
                                <div class="form_item_underline">
                                    {{ dataObj.currencyUnit }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="税率" v-if="dataObj.currencyUnit === '人民币'">
                                <div class="form_item_underline">
                                    {{ dataObj.goodsInfo.tax }}%
                                </div>
                            </el-form-item>
                            <el-form-item label="单价类型" v-else>
                                <div class="form_item_underline">
                                    {{ dataObj.goodsInfo.priceType }}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="结算方式">
                                <div class="form_item_underline">
                                    {{ getSettlementName(dataObj.settlePlans) }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="结算方式">
                                <div class="form_item_underline">
                                    {{ getSettlementText(dataObj.settlePlans) }}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="footer">
            <el-button-group>
                <el-button type="default"
                           class="footer_btn"
                           @click="close">
                    <span style="margin-left: 5px;">返回</span>
                </el-button>
            </el-button-group>
        </div>
    </div>
</template>

<script>
import calculate from '../../../plugins/calculate';

export default {
    name: 'DetailSaleOrder',
    data() {
        return {
            dataObj: {
                goodsInfo: {}
            },
            settleList: [],
            stock: false
        }
    },
    async created() {
        await this.getSettlementList();
        if (this.$route.params.id) {
            await this.setDefaultValue(this.$route.params.id);
        }
    },
    computed: {
        getTotalFee() {
            if (this.dataObj.goodsInfo) {
                return this.dataObj.goodsInfo.totalPrice || 0;
            }
            return 0;
        },
        getOtherFee() {
            if (this.dataObj.goodsInfo && this.dataObj.goodsInfo.surchargeFeeList) {
                return this.dataObj.goodsInfo.surchargeFeeList.reduce((a, b) => calculate.add(a, b.fee || 0), 0);
            }
            return 0;
        },
        customerData() {
            if (this.dataObj.custName) {
                return `${this.dataObj.custName || ''}/${this.dataObj.contacts || ''}/${this.dataObj.contactInfo || ''}`;
            }
            return '';
        }
    },
    methods: {
        async setDefaultValue(id) {
            const { data } = await this.qGet(`/sales/sale_order/${id}`);
            if (data) {
                this.dataObj = {
                    ...data,
                    ...data.baseInfo,
                    ...data.custInfo
                };
                await this.getStock(this.dataObj.goodsInfo.goodsId);
            }
        },
        async getStock(id) {
            const { data } = await this.qGet(`/base/info/product/${id}`);
            if (data) {
                this.stock = data.stock;
            }
        },
        async getSettlementList() {
            const { data } = await this.qGet('/customer/settle');
            if (data && data.length > 0) {
                this.settleList = [...data];
            }
        },
        isEqualSettlement(arr1, arr2) {
            if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
                return false;
            }
            if (arr1.length !== arr2.length) {
                return false;
            }
            for (let i = 0; i < arr1.length; i++) {
                if (arr1[i].day !== arr2[i].day) {
                    return false;
                }
                if (arr1[i].month !== arr2[i].month) {
                    return false;
                }
                if (arr1[i].percent !== arr2[i].percent) {
                    return false;
                }
                if (arr1[i].way !== arr2[i].way) {
                    return false;
                }
            }
            return true;
        },
        getSettlementName(settlePlans) {
            if (!settlePlans) {
                return '';
            }
            const i = this.settleList.findIndex(item => this.isEqualSettlement(item.settlePlan, settlePlans));
            if (i !== -1) {
                return this.settleList[i].custSettle;
            }
            return '自定义';
        },
        getSettlementText(settlePlans) {
            if (!settlePlans) {
                return '';
            }
            let arr = [];
            settlePlans.forEach(settlePlan => {
                if (settlePlan.way === '定金') {
                    arr.push(`定金:${settlePlan.percent}%`);
                } else if (settlePlan.way === '现款') {
                    arr.push(`现款:${settlePlan.percent}%`);
                } else if (settlePlan.way === '月结') {
                    arr.push(`欠款-月结${settlePlan.percent}%-${settlePlan.month}月`);
                } else if (settlePlan.way === '日结') {
                    arr.push(`欠款-日结${settlePlan.percent}%-${settlePlan.day}日`);
                }
            });
            return arr.join('，');
        },
        close(isPush = false) {
            this.$store.commit('tab/deleteTab', {
                item: this.$store.state.tab.view.title,
                route: this.$route,
                pushUrl: isPush ? this.pushUrl : undefined
            });
        }
    }
}
</script>

<style lang="scss">
    .new_sale_order_batch {
        .title {
            display: flex;
            align-items: center;
            justify-content: end;
            padding: 0 20px;
        }
        .sale_order_no {
            font-size: 20px;
            font-weight: 700;
        }
        .cust_order_no {
            font-size: 18px;
        }
        .info {
            display: flex;
            width: calc(100% - 20px);
            padding: 0 10px;
            .info_item {
                width: 50%;
                padding: 10px;
                .info_item_title {
                    width: calc(100% - 16px);
                    font-size: 14px;
                    font-weight: 700;
                    width: 60px;
                    background-color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 8px 8px 0 0;
                    padding: 4px 8px;
                }
                .info_item_content {
                    width: calc(100% - 40px);
                    background-color: #fff;
                    padding: 15px 20px;
                    border-radius: 0 8px 8px 8px;
                    .form_item_underline {
                        height: 40px;
                        border-bottom: 1px solid #000;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-weight: 700;
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }
        .goods {
            width: calc(100% - 40px);
            padding: 20px;
            .goods_title {
                width: calc(100% - 16px);
                font-size: 14px;
                font-weight: 700;
                width: 60px;
                background-color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 8px 8px 0 0;
                padding: 4px 8px;
            }
            .goods_content {
                width: calc(100% - 40px);
                background-color: #fff;
                padding: 25px 20px;
                border-radius: 0 8px 8px 8px;
                .goods_content_title {
                    display: flex;
                    align-items: center;
                    padding-bottom: 20px;
                    .goods_no {
                        font-weight: 700;
                        font-size: 18px;
                    }
                    .stock {
                        width: 36px;
                        height: 16px;
                        border-radius: 8px;
                        line-height: 16px;
                        text-align: center;
                        background-color: rgba(245, 154, 35, 1);
                        color: #fff;
                        font-size: 10px;
                        margin-left: 10px;
                    }
                }
                .goods_content_item {
                    width: 100%;
                    word-break: break-all;
                    padding-bottom: 10px;
                    .value {
                        font-weight: 700;
                        font-size: 16px;
                    }
                }
            }
        }
        .settlement {
            width: calc(100% - 40px);
            padding: 20px;
            margin: 0 0 100px 0;
            .settlement_title {
                width: calc(100% - 16px);
                font-size: 14px;
                font-weight: 700;
                width: 60px;
                background-color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 8px 8px 0 0;
                padding: 4px 8px;
            }
            .settlement_content {
                width: calc(100% - 40px);
                background-color: #fff;
                padding: 15px 20px;
                border-radius: 0 8px 8px 8px;
                display: flex;
                .form_item_underline {
                    height: 40px;
                    border-bottom: 1px solid #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-weight: 700;
                    display: flex;
                    align-items: center;
                }
            }
        }
        .footer {
            display: flex;
            justify-content: end;
            position: fixed;
            bottom: 20px;
            right: 30px;
            margin: 10px;
            .footer_btn {
                width: 120px;
                height: 40px;
                font-size: 16px;
            }
        }
        .detail {
            color: rgb(2, 167, 240);
            font-size: 16px;
        }
    }
    .production_process_list {
        display: flex;
        align-items: center;
        margin-top: 20px;
        .production_process_item {
            border: 1px solid #000;
            padding: 20px;
            min-height: 160px;
            margin-right: 10px;
            .production_process_item_title {
                font-weight: 700;
                font-size: 18px;
                margin-bottom: 10px;
            }
            .production_process_radio {
                // padding: 10px 0;
                min-height: 30px;
                min-width: 200px;
                display: flex;
                align-items: center;
                .rent_number {
                    display: flex;
                    align-items: center;
                    position: relative;
                    width: 100px;
                    .el-input__inner {
                        padding-right: 40px;
                        z-index: 10;
                    }
                    .number_input_append {
                        position: absolute;
                        right: 1px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 30px;
                        height: calc(100% - 2px);
                        background-color: #F5F7FA;
                        color: #909399;
                        border-left: 1px solid #DCDFE6;
                        border-radius: 0 4px 4px 0;
                        font-size: 14px;
                        z-index: 1;
                    }
                }
                // .production_process_radio_text {
                //     height: 28px;
                //     line-height: 28px;
                // }
            }
        }
    }
    .input_empty {
        .el-input__inner {
            border: 1px solid red !important;
        }
    }
    .el-input-number {
        .el-input__inner {
            text-align: left !important;
        }
    }
    .dialog-footer {
        .el-button {
            width: 100px;
            height: 36px;
        }
    }
    .select_tag_list {
        display: flex;
        height: 40px;
        align-items: center;
        .select_tag {
            height: 20px;
            line-height: 20px;
            padding: 5px 15px;
            margin: 0 5px;
            border: 1px solid rgba(215, 215, 215, 1);
            border-radius: 15px;
            color: #333333;
            font-size: 14px;
            cursor: pointer;
        }
        .is_selected {
            border: 1px solid rgba(2, 167, 240, 1);
            background-color: rgba(183, 233, 255, 1);
            color: #02A7F0;
        }
    }
</style>
